import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/theme/global.css";
import "@/shared/ui/ui.css";
import { App } from "@/app/App";
import { installStaleChunkReload } from "@/app/reloadOnStaleChunk";

// 换版本以后旧页面取不到分包：自动刷新一次（UI-STALE-CHUNK-RELOAD-01），要在渲染前装上
installStaleChunkReload();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
